import script from "./BulkDealManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkDealManagement.vue?vue&type=script&setup=true&lang=js"

import "./BulkDealManagement.vue?vue&type=style&index=0&id=4e9eceec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9eceec"]])

export default __exports__